import MxSelectAgenciesField, {
  MxSelectAgenciesFieldProp
} from "@rf-l1/form/selects/MxSelectAgenciesField";
import { useMxFieldControllerContext } from "../../../../context/MxFieldController";

type omit = "value" | "id" | "name" | "testId" | "items" | "onChange";

export type MxFormSelectAgenciesFieldProp = Omit<MxSelectAgenciesFieldProp, omit>;

const MxFormSelectAgenciesField = (props: MxFormSelectAgenciesFieldProp) => {
  const { onChange, onBlur, name, value, invalid, id, testId, inputRef } =
    useMxFieldControllerContext();

  return (
    <MxSelectAgenciesField
      {...props}
      id={id}
      testId={testId}
      onChange={onChange}
      onBlur={onBlur}
      name={name}
      value={value}
      error={invalid}
      inputRef={props.usePortal ? undefined : inputRef}
    />
  );
};

export default MxFormSelectAgenciesField;
